<ng-content></ng-content>

<cp-icon class="btn-icon" *ngIf="showIcon" [type]="cpicon"></cp-icon>
